import { render, staticRenderFns } from "./Collab.vue?vue&type=template&id=189a02fd&scoped=true&"
import script from "./Collab.vue?vue&type=script&lang=js&"
export * from "./Collab.vue?vue&type=script&lang=js&"
import style0 from "./Collab.vue?vue&type=style&index=0&id=189a02fd&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a02fd",
  null
  
)

export default component.exports